import { useNavigate } from 'react-router-dom';

export const redirectToMaintenancePage = (errMsg?: string): void => {
  const params = new URLSearchParams(errMsg ? { errMsg } : {});
  window.location.href = `/Maintenance?${params.toString()}`;
};

export const redirectToUserOfflinePage = (): void => {
  window.location.href = `/userOffline`;
};

export const redirectToResetPw = (email: string): void => {
  window.location.href = `/SystemUpgradePasswordUpgrade?email=${email}`;
};
